<template>
    <div>
        <div class="headingWizard">
            Cancel Appointment
        </div>
        <div class="widthContainer">
            <div class="pageLayout">
                <div class="infoText">
                    <div class="error">
                        <p class="m-0">
                            <b>
                                You have selected to cancel your appointment.
                            </b>
                        </p>
                    </div>
                    <div>
                        <p class="mt-2">
                            Your appointment details are:
                        </p>
                    </div>
                </div>
                <div class="formConatiner">
                    <div class="infoTable">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div class="lableText"> Appointment Date </div>
                                        <div class="detailsText">
                                            {{ appointmentDateString }}
                                        </div>
                                    </th>
                                    <th>
                                        <div class="lableText">
                                            Appointment Time
                                        </div>
                                        <div class="detailsText">
                                            {{ formatTime12(appointmentDetails.startTime) }}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div class="lableText">
                                            Name
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.name }}
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Mobile Number
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.phoneNumber">
                                                {{ appointmentDetails.phoneNumber }}
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="lableText">
                                            Email Address
                                        </div>
                                        <div class="detailsText">
                                            <span v-if="appointmentDetails.email">
                                                {{ appointmentDetails.email }}
                                            </span>
                                            <span v-else>
                                                -
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="lableText">
                                            Service Name
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.serviceName }}
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                                  <tr>
                                    <td colspan="2" class="p-0">
                                        <div class="appInfoDetails" v-if="isVehicalShow">
                                            <div class="lableText">
                                                Vehicle Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.vehicleNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isNoticeShow">
                                            <div class="lableText">
                                                Notice Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.noticeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isVacShow">
                                            <div class="lableText">
                                                VAC Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.vacNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isPARFShow">
                                            <div class="lableText">
                                                PARF Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.parfNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isCEORShow">
                                            <div class="lableText">
                                                COE Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.coeNumber) }}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isTcoeShow">
                                            <div class="lableText">
                                                TCOE Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.tcoeNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="ishVParkShow">
                                            <div class="lableText">
                                                HV Park Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.hvParkNumber)}}
                                            </div>
                                        </div>

                                        <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                            <div class="lableText">
                                                Device Number
                                            </div>
                                            <div class="detailsText">
                                                {{capitalize(appointmentDetails.deviceNumber)}}
                                            </div>
                                        </div>

                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <div class="lableText">
                                            Note to LTA
                                        </div>
                                        <div class="detailsText" v-html="appointmentDetails.remarks">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div class="lableText">
                                            Appointment Reference ID
                                        </div>
                                        <div class="detailsText">
                                            {{ appointmentDetails.referenceNumber }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td colspan="2">
                                        <div>
                                            <label>
                                                Reason for Cancellation<span class="requiredIcon">&#42;</span>
                                            </label>
                                            <div>
                                                <Textarea :autoResize="true" class="width100 Textareahight" type="text"
                                                    v-model="appointmentCancel.remarks"
                                                     @input="v$.appointmentCancel.remarks.$touch()"
                                                    v-bind:class="{ 'p-error': v$.appointmentCancel.remarks.$error }" />
                                                <div class="error"
                                                    v-if="v$.appointmentCancel.remarks.$dirty && v$.appointmentCancel.remarks.required.$invalid">
                                                    Reason is required</div>
                                                <div class="error"
                                                    v-if="v$.appointmentCancel.remarks.$dirty && v$.appointmentCancel.remarks.maxLength.$invalid">
                                                    Reason must not exceed 300 characters</div>
                                                <div class="error text-left"
                                                    v-if="v$.appointmentCancel.remarks.$dirty && v$.appointmentCancel.remarks.val.$invalid">
                                                    You have entered an invalid character. <br /> Only the following
                                                    characters are allowed: , ' @ / - _ $ # ? . &
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="mt-2">
                        To cancel Your appointment, please click Confirm.<br />
                        Otherwise, click Back to return to previous page.
                    </p>
                </div>
                <div class="buttonContainer paddingBottom">
                    <div class="p-col-12">
                        <div class="float-left">
                            <Button label="< Back" @click="onBackAction" class="linkBtn" />
                        </div>
                        <div class="float-right">
                            <Button label="Confirm " @click="onCancelAction" class="btn p-button-raised" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.infoText {
    margin-top: 28px;
    float: left;
    width: 100%;
    margin-bottom: 5px;
}

.paddingBottom {
    padding-bottom: 50px;
}

.Textareahight {
    min-height: 90px;
}

.p-error {
  border: 1px solid #ab0000 !important;
}
</style>
<script setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import useVuelidate from '@vuelidate/core'
import { required, maxLength } from '@vuelidate/validators'
import { useApiService } from '@/utils/useApiService'
import { useNotifications } from '@/utils/useNotifications'
const store = useStore()
const router = useRouter()
const { fetchWrapperForGet, fetchWrapperForPut } = useApiService()
const { notifyError,notifyInfoError } = useNotifications()
const id = ref(null)
const appointmentDateString = ref('')

const isVehicalShow = ref(false)
const isNoticeShow = ref(false)
const isVacShow = ref(false)
const isPARFShow = ref(false)
const isCEORShow = ref(false)
const isTcoeShow = ref(false)
const ishVParkShow = ref(false)
const isDeviceNumberShow = ref(false)

const appointmentDetails = reactive({
    remarks: '', postBookingMessage: '', vehicleNumber: '', noticeNumber: '', vacNumber: '', deviceNumber: '',
    parfNumber: '', coeNumber: '', tcoeNumber: '', hvParkNumber: '', serviceName: '', name: '', phoneNumber: '', email: '', cancelledRemark: '',
    appointmentDateTime: '', tag: '', referenceNumber: '', generateDateTime: '', appointmentDate: '', startTime: '', endTime: '', noteToLta: ''
})

const appointmentCancel = reactive({ id: '', remarks: '' })

const rules = {
    appointmentCancel: {
        remarks: {
            required,
            maxLength: maxLength(300),
            val: val => !val || /^([a-zA-Z0-9 @,‘’'#\-._$?&\/]*)?$/.test(val)
        }
    }
}
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
function formatTime12(value) {
    if (value) {
        const [hoursStr, minutesStr] = value.split(':');
        let hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // convert 0 to 12 for 12-hour format

        return `${hours}:${String(minutes).padStart(2, '0')} ${ampm}`;
    }
    return value;
}
const v$ = useVuelidate(rules, { appointmentCancel })

function onBackAction() {
    router.push({ path: '/enquireappointment/2' })
}

function getData() {
    Object.assign(appointmentDetails, store.getters.getAppointmentAcknowlegement)
    appointmentDateString.value = store.getters.getAppointmentDateString
}

function okFunction() {
    store.dispatch('reset').then(() => {
        router.push({ path: '/enquireappointment/1' })
    })
}

function onCancelAction() {
    appointmentCancel.id = store.getters.getAppointmentId
    v$.value.$touch()
    if (v$.value.$invalid) return

    if (appointmentCancel.id) {
        fetchWrapperForGet('api/HeartBeat', false, false, false).then(() => {
            fetchWrapperForPut('api/mop/appointments/cancel', appointmentCancel, false, true, true, false)
                .then(() => {
                    appointmentDetails.cancelledRemark = appointmentCancel.remarks
                    store.dispatch('setAppointmentAcknowlegement', appointmentDetails).then(() => {
                        router.push({ path: '/cancelappointment' })
                    })
                })
        }).catch(err => {
            if (err.errorCode === 422) {
                notifyInfoError("Your session has expired due to inactivity. To download appointment details, please select \"Enquire / Manage Appointment\" option and try again.", okFunction)
            } else {
                notifyError(err)
                getSchedule()
            }
        })
    }
}

// computed watches
const onVehicalNumberChange = computed(() => appointmentDetails.vehicleNumber)
const onNoticeNumberChange = computed(() => appointmentDetails.noticeNumber)
const onVACNumberChange = computed(() => appointmentDetails.vacNumber)
const onPARFNumberChange = computed(() => appointmentDetails.parfNumber)
const onCOENumberChange = computed(() => appointmentDetails.coeNumber)
const onTCOENumberChange = computed(() => appointmentDetails.tcoeNumber)
const onHVParkNumberChange = computed(() => appointmentDetails.hvParkNumber)
const onDeviceNumberChange = computed(() => appointmentDetails.deviceNumber)

watch(onVehicalNumberChange, val => { if (val) isVehicalShow.value = true })
watch(onNoticeNumberChange, val => { if (val) isNoticeShow.value = true })
watch(onVACNumberChange, val => { if (val) isVacShow.value = true })
watch(onPARFNumberChange, val => { if (val) isPARFShow.value = true })
watch(onCOENumberChange, val => { if (val) isCEORShow.value = true })
watch(onTCOENumberChange, val => { if (val) isTcoeShow.value = true })
watch(onHVParkNumberChange, val => { if (val) ishVParkShow.value = true })
watch(onDeviceNumberChange, val => { if (val) isDeviceNumberShow.value = true })

onMounted(getData)
</script>
